import FullScreenDialog from '../full-screen-dialog/FullScreenDialog';
import SettingsBar from '../settings-bar/SettingsBar';
import { useTranslation } from 'react-i18next';
//import { useOfflineDetectContext } from '../../contexts/offline-detect-context/OfflineDetectContext';
import MobileGroupHierarchy from '../group-hierarchy/mobile/MobileGroupHierarchy';
import { useEffect, useMemo, useState } from 'react';
//import { useTheme } from '@mui/system';
import { INavigationItem } from '../../services/navigation-data-service/Models';
import { routesByViewID } from '../../routes/routes';
import { UIViewEnum } from '../../common/enums/UIViewEnum';
import WithIsLoadingHOC from "../../hocs/is-loading-hoc/IsLoadingHOC";
import useNavigateTo from '../../hooks/use-navigate-to/useNavigateTo';
import { useOfflineDetectContext } from "../../contexts/offline-detect-context/UseOfflineDetectContext";
import { useUserContext } from '../../contexts/user-context/UserContext';
import { useUserDefaultViews } from '../../queries/user-default-view/UseUserDefaultViews';
import { useQueryNotifications } from '../../queries/UseQueryNotifications';
import { eLynxObjectTypeEnum } from '../../common/enums/eLynxObjectType';
import { useEvaluateFeature } from '../../queries/features/UseEvaluateFeature';
import { FeatureConstants } from '../../services/features-data-service/Models';
import NavigationGroupTree from '../navigation/NavigationGroupTree';


const MobileGroupHierarchyWithLoading = WithIsLoadingHOC(MobileGroupHierarchy);


export type MobileHierarchyProps = {
    open: boolean;
    onClose: () => void
};

export default function MobileHierarchy({open, onClose}: MobileHierarchyProps) {
    
    const { t } = useTranslation();
    const [offlineState] = useOfflineDetectContext();    
    const [userState] = useUserContext();

    const { data: navigationV2Feature } = useQueryNotifications(useEvaluateFeature)({
        feature: FeatureConstants.NavigationV2,
    });

    const navigationV2 = (navigationV2Feature ?? false);

    const { data: defaultViews } = useQueryNotifications(useUserDefaultViews)({
        enabled: !offlineState.offline
    });

    const groupViewID = useMemo(() => {

        return defaultViews?.find(o => o.objectType === eLynxObjectTypeEnum.Group && 
            o.user?.id === userState.user?.id)?.viewID ?? 
            defaultViews?.find(o => o.objectType === eLynxObjectTypeEnum.Group && 
                !o.user?.id)?.viewID ??
            UIViewEnum.Group_SummaryListing;

    }, [
        defaultViews,
        userState.user?.id
    ]);

    const groupRoute = useMemo(() => {
        const route = routesByViewID.get(groupViewID);
        return route;
    }, [
        groupViewID
    ]);


    //const [offlineState] = useOfflineDetectContext();

    const [loading, setLoading] = useState(true);    
    const navigateTo = useNavigateTo();
    //const theme = useTheme();
    

    const onSelected = (item: INavigationItem): void => {

        let viewID = groupViewID;

        const route = routesByViewID.get(viewID);
        
        if (!route.allowMobile || (!route.allowOffline && offlineState.offline)) {
            viewID = UIViewEnum.Group_SummaryListing;
        }
        

        const path = routesByViewID.get(viewID)?.fullPath;
        navigateTo(`${path}?groupID=${item.objectID}`);

        if (onClose) {
            onClose();
        }
    };

    useEffect(() => {

        const scrollToSelected = () => {
            // Scope the search to the tree structure
            const selectedNode = document.querySelector('#mobile-grp-tree [role="tree"] .Mui-selected');
            
            if (selectedNode) {
                selectedNode.scrollIntoView({
                behavior: 'smooth',
                //block: 'nearest', // Ensures it scrolls only as much as needed
                block: 'center',
                });
            }
        };        

        if (open) {
            setTimeout(() => {
                scrollToSelected();
            }, 1000);
        }

    },[
        open,
        groupRoute
    ]);        


    return (

        <FullScreenDialog open={open} onClose={onClose}>

                <SettingsBar title={t('navigation.groupHierarchy')} 
                            onClose={() => onClose()}
                            hideAction={true}
                             />                


            {navigationV2 ?

                <NavigationGroupTree
                    id="mobile-grp-tree"
                    route={groupRoute}
                    onClick={(selectedItem, shiftKey, ctrlKey) => {
                            onSelected(selectedItem);
                    }}
                 />


                :

                    <MobileGroupHierarchyWithLoading 
                        isLoading={loading}
                        onLoading={setLoading}                    
                        onSelected={onSelected} />

            }
        </FullScreenDialog>
        
    );
  }
